import { ModuleType, ImageSizes } from '../types';

export const RECTANGULAR_SIZES = {
  [ImageSizes.SMALL]: '40px',
  [ImageSizes.MEDIUM]: '64px',
  [ImageSizes.LARGE]: '88px'
};

export const SQUARE_SIZES = {
  [ImageSizes.SMALL]: '40px',
  [ImageSizes.MEDIUM]: '80px',
  [ImageSizes.LARGE]: '120px'
};

export const VIDEO_BACKGROUND = {
  type: ModuleType.VIDEO,
  descriptor: {
    video: {
      source: ''
    },
    mode: 'player-no-controls',
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      objectFit: 'cover',
      zIndex: 0
    },
    computedStyle: ''
  },
  isVisible: true,
  isEditable: false
};

export const DEFAULT_LOGO = 'https://d3on5ehsnqzzp4.cloudfront.net/Splash/Elevate/logo-generic.png';

export const DEFAULT_QUOTE_VIDEO = 'https://d3on5ehsnqzzp4.cloudfront.net/Splash/Elevate/splash-quote.mp4';